<template>
   <div>
        <validation-observer ref="observer" v-slot="{ passes }">
        <span v-if="!updateItem" @dblclick="updateItem = true">{{ item?.name }}</span>
        <b-form v-if="updateItem" inline @submit.prevent="passes(onFormSubmit)" novalidate>
            <b-button size="sm" class="mr-1" variant="warning" @click="updateItem = false">Undo</b-button>
            <validation-provider vid="name" v-slot="{ errors }">
                <b-form-input size="sm" :state="errors[0] ? false : null" id="name" name="name" v-model="form.name" placeholder="Add reason..." />
            </validation-provider>
            <b-button size="sm" type="submit" class="ml-1" variant="success">Update</b-button>
            <b-button size="sm" type="button" class="ml-1" variant="danger" @click="onDelete">Delete</b-button>
        </b-form>
        </validation-observer>
    </div>
</template>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapGetters, mapState, mapActions } from "vuex"

export default FormExtension.extend({
    name: 'user-update-consultation-reason',
    props: ['item'],
    data() {
        return {
            form: new Form({
                name: "",
                consistency_token: null
            }),

            updateItem: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler(val) {
                this.isDirty = this.form.dirty()

                if (this.isDirty) {
                    this.dirty()
                }else{
                    this.validated()
                }
            }
        },
        item: {
            immediate: true,
            handler(val) {
                this.form.withData(val)
            }
        },
    },
    methods: {
        ...mapActions('planning', ['updateConsultReasonTypeById', 'deleteConsultReasonTypeById']),
        onFormSubmit() {
            this.updateConsultReasonTypeById({id: this.item.id, data: this.form.data()}).then(() => {
                this.reset()
                this.notify('Consultation reasons update', "Consultation reasons was update successfully")
                this.$emit('updated')
            })
            .catch(errors => {
                if (errors.response) {
                    this.$refs.observer?.setErrors(errors.response.data)
                    this.hasErrors = true
                }
            })
        },
        onDelete() {
            this.deleteConsultReasonTypeById(this.item?.id).then(() => {
                this.notify('Consultation reasons deleted', "Consultation reasons was deleted successfully")
                this.updateItem = false
                this.validated()
                this.$emit('updated')
            })
        },
        reset() {
            this.form.reset()
            this.$nextTick(() => {
                this.$refs.observer?.reset()
                this.updateItem = false
                this.hasErrors = false
                this.validated()
            })
        }
    }
})
</script>